

<div class="sucess">
    <img src="../../../assets/images/ic_error_icon.svg">    
    <p class="mt-3"> {{languageCheck == 2 ? 'Payment error' :  
                       languageCheck == 1 ? 'error en el pago' : 'erro de pagamento'}}</p>
    </div>